var _rect, _title, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDropdown = function SvgDropdown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    style: {},
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.43,12.78a.61.61,0,0,1-.86,0L2.45,5.67a.62.62,0,0,1,0-.87L4,3.22a.61.61,0,0,1,.86,0L10,8.31l5.1-5.1a.61.61,0,0,1,.86,0L17.55,4.8a.62.62,0,0,1,0,.87Z",
    id: "svg_1",
    className: "selected",
    fillOpacity: 1,
    fill: "#8ed6c9"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDropdown);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNiIgc3R5bGU9IiI+PHJlY3QgaWQ9ImJhY2tncm91bmRyZWN0IiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4PSIwIiB5PSIwIiBmaWxsPSJub25lIiBzdHJva2U9Im5vbmUiLz48ZyBjbGFzcz0iY3VycmVudExheWVyIiBzdHlsZT0iIj48dGl0bGU+TGF5ZXIgMTwvdGl0bGU+PHBhdGggZD0iTTEwLjQzLDEyLjc4YS42MS42MSwwLDAsMS0uODYsMEwyLjQ1LDUuNjdhLjYyLjYyLDAsMCwxLDAtLjg3TDQsMy4yMmEuNjEuNjEsMCwwLDEsLjg2LDBMMTAsOC4zMWw1LjEtNS4xYS42MS42MSwwLDAsMSwuODYsMEwxNy41NSw0LjhhLjYyLjYyLDAsMCwxLDAsLjg3WiIgaWQ9InN2Z18xIiBjbGFzcz0ic2VsZWN0ZWQiIGZpbGwtb3BhY2l0eT0iMSIgZmlsbD0iIzhlZDZjOSIvPjwvZz48L3N2Zz4=";